import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import CompanyService from 'services/company.service';
import Loading from 'components/Loading';

export const RegulatoryDocument = () => {  
  const [blobUrl, setBlobUrl] = useState<string>();
  const { id } = useParams()
  const _companyServices = new CompanyService()
  
  useEffect(() => {    
    if(id?.trim() !== "")
      getRegulatoryDocument();
  }, [id]);

  useEffect(() => {    
    if(blobUrl?.trim() !== "" && blobUrl !== undefined)
      forwardToBlob();
  }, [blobUrl]);

  const getRegulatoryDocument = async () => {
    await _companyServices.getRegulatoryDocumentBlobUrl(id || "")
      .then((result: any) => {        
        if (result)
          setBlobUrl(result);
      });
  };
  
  const forwardToBlob = () =>{
    window.location.href = blobUrl!;
  };

  return (
    <>
      <Loading onlySpinner={true} size={20} />
    </>
  );
};